import { Differentiation } from '@zola/zola-ui/src/components/PreAuthV3';
import { BackgroundType } from '@zola/zola-ui/src/components/PreAuthV3/FeaturedImage';
import COLORS from '@zola/zola-ui/src/styles/emotion/colors3';

import DETAILS_1 from '~/pages/couples/explore/assets/details-1.png';
import DETAILS_2 from '~/pages/couples/explore/assets/details-2.png';
import DETAILS_3 from '~/pages/couples/explore/assets/details-3.png';
import DETAILS_4 from '~/pages/couples/explore/assets/details-4.png';
import DETAILS_5 from '~/pages/couples/explore/assets/details-5.png';
import { getAssetImageUrl } from '~/util/imageUtils';

const LandingDifferentiation = () => {
  return (
    <Differentiation
      title={{
        children: (
          <>
            The difference is in the <strong>details</strong>
          </>
        ),
      }}
      content={[
        {
          id: 'details-1',
          subtitle: 'The fun way to find your favorites',
          description:
            'Take our quiz to discover vendors that are a perfect fit. Or use our smart filters to find exactly what you want.',
          image: {
            background: {
              type: BackgroundType.COLOR,
              parameters: {
                color: COLORS.ROSE_100,
              },
            },
            foregroundImage: {
              imgType: 'png',
              desktopSrc: getAssetImageUrl(DETAILS_1, { width: 1200 }),
              tabletSrc: getAssetImageUrl(DETAILS_1, { width: 800 }),
              mobileSrc: getAssetImageUrl(DETAILS_1, { width: 600 }),
            },
          },
          button: {
            text: 'Take our quiz',
            href: '/inspiration/onboard',
          },
        },
        {
          id: 'details-2',
          subtitle: 'Only vendors who match our values',
          description: 'Every vendor on Zola has said Yes to our Vendor Vows.',
          image: {
            background: {
              type: BackgroundType.COLOR,
              parameters: {
                color: COLORS.WINE_100,
              },
            },
            foregroundImage: {
              imgType: 'png',
              desktopSrc: getAssetImageUrl(DETAILS_2, { width: 1200 }),
              tabletSrc: getAssetImageUrl(DETAILS_2, { width: 800 }),
              mobileSrc: getAssetImageUrl(DETAILS_2, { width: 600 }),
            },
          },
        },
        {
          id: 'details-3',
          subtitle: 'Curate and connect from one open tab',
          description:
            'Say goodbye to dozens of open tabs, lost connections, and missed calls. From saving your favorites to keeping track of your bookings, you can do it all right here.',
          image: {
            background: {
              type: BackgroundType.COLOR,
              parameters: {
                color: COLORS.MARINE_100,
              },
            },
            foregroundImage: {
              imgType: 'png',
              desktopSrc: getAssetImageUrl(DETAILS_3, { width: 1200 }),
              tabletSrc: getAssetImageUrl(DETAILS_3, { width: 800 }),
              mobileSrc: getAssetImageUrl(DETAILS_3, { width: 600 }),
            },
          },
        },
        {
          id: 'details-4',
          subtitle: 'Get inspired by Real Weddings',
          description:
            'Scroll through the stunning photos, favorite the ones you love, and connect with the vendors behind them.',
          image: {
            background: {
              type: BackgroundType.COLOR,
              parameters: {
                color: COLORS.FOREST_100,
              },
            },
            foregroundImage: {
              imgType: 'png',
              desktopSrc: getAssetImageUrl(DETAILS_4, { width: 1200 }),
              tabletSrc: getAssetImageUrl(DETAILS_4, { width: 800 }),
              mobileSrc: getAssetImageUrl(DETAILS_4, { width: 600 }),
            },
          },
        },
        {
          id: 'details-5',
          subtitle: 'Ask the experts',
          description: 'Not sure what to book first or what to ask? We\u2019re here to help.',
          image: {
            background: {
              type: BackgroundType.COLOR,
              parameters: {
                color: COLORS.BAY_100,
              },
            },
            foregroundImage: {
              imgType: 'png',
              desktopSrc: getAssetImageUrl(DETAILS_5, { width: 1200 }),
              tabletSrc: getAssetImageUrl(DETAILS_5, { width: 800 }),
              mobileSrc: getAssetImageUrl(DETAILS_5, { width: 600 }),
            },
          },
        },
      ]}
      isPhotoOnRight={false}
    />
  );
};

export default LandingDifferentiation;
